module.exports = __webpack_public_path__ + "img/05.734f5194.jpg";